<h2 mat-dialog-title>{{ data?.title || "Modify Confirm" }}</h2>
<div mat-dialog-content>
  {{
    data?.message ||
      "You will be redirected to the booking engine to complete modifications. Proceed?"
  }}
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button [mat-dialog-close]="true">Yes</button>
</div>
